export default {
    cemeteries: {
        titles: "Cemitérios",
        title: "Cemitério",
        label: "@:cemeteries.titles",
        title_modal: "Adicionar Cemitério | Cemitério: {code}",
        model: {
            code: "Código",
            name: "Nome",
            description: "Descrição",
            phone: "Telefone",
            email: "Email",
            web_site: "Site Web",
            working_hours: "Horário de Funcionamento",
            admin1_code: "Distrito",
            admin2_code: "Concelho",
            admin3_code: "Freguesia",
            admin4_code: "Localidade",
            street: "Morada",
            area: "Área",
            perimeter: "Perímetro",
            obs: "Observações",
            maintenance: "Manutenção",
            status: "Ativo",

            administration: {
                sector_statistic: {
                    total_sectors: "Total de Setores",
                    total_interments: "Total de Enterros"
                }
            }
        },
        list: {},
        tabs: {
            administration: "Administração",
            public: "Informação Geral"
        },
        actions: {
            administration: {
                sector_statistic: {
                    see_sectors: "Visualizar Setores"
                }
            }
        },
        msg: {
            "confirm-delete": "Deseja eliminar o Cemitério <strong class='font-weight-bold'>{code}</strong>?"
        },
        buttons: {
            save: "@:global.save",
            delete: "@:global.remove",
            view: "@:global.form"
        }
    },
    occupations: {
        titles: "Ocupações",
        title: "Ocupação",
        label: "@:occupations.titles",
        title_modal: "Adicionar Ocupação | Ocupação: {code}",
        model: {
            cemetery: "@:cemeteries.title",
            sector: "Setor",
            row: "Linha",
            number: "Número",
            code: "Código",
            name: "Nome",
            occupation_type: "Tipo",
            occupation_state_type: "Estado",
            occupation_direction_type: "Direção",
            occupation_position_type: "Posição",
            burials_capacity: "Capacidade para Sepultura",
            burials_capacity_abbr: "Capacidade Sepultura",
            burials_capacity_short: "Sepultura",
            entombment_capacity: "Capacidade para Monumento",
            entombment_capacity_abbr: "Capacidade Monumento",
            entombment_capacity_short: "Monumento",
            cremation_capacity: "Capacidade para Cremação",
            cremation_capacity_abbr: "Capacidade Cremação",
            cremation_capacity_short: "Cremação",
            total_capacity: "Capacidade Total",
            price: "Preço",
            show_price: "Mostrar Preço",
            inscription: "Inscrição na lápide",
            obs: "Observações",
            status: "Ativo",
            interments: "@:interments.titles",

            interment: {
                titles: "@:interments.titles",
                years: "Anos",
                interment_at: "@:interments.model.interment_at",
                interment_depth: "@:interments.model.interment_depth",
                cremation_location: "@:interments.model.cremation_location",

                entity: {
                    religion: "@:entities.model.religion",
                    occupation: "@:entities.model.occupation",
                    cause_death: "@:entities.model.cause_death",
                    address: "@:entities.model.address",
                    full_address: "@:entities.model.full_address"
                }
            },
            deed_owner: {
                titles: "@:deed_owners.titles",
                right_type: "@:deed_owners.model.right_type",
                term_right_type: "@:deed_owners.model.term_right_type",
                application_at: "@:deed_owners.model.application_at",
                expiry_at: "@:deed_owners.model.expiry_at",
                certificate_number: "@:deed_owners.model.certificate_number",
                process_number: "@:deed_owners.model.process_number",
                license_number: "@:deed_owners.model.license_number",
                registration_number: "@:deed_owners.model.registration_number",
                service_need: "@:deed_owners.model.service_need",
                paid: "@:deed_owners.model.paid",
                not_paid: "@:deed_owners.model.not_paid",
                files: "@:deed_owners.model.files"
            }
        },
        list: {},
        tabs: {
            interments: "@:occupations.model.interment.titles",
            deed_owners: "@:occupations.model.deed_owner.titles"
        },
        form: {
            capacity: "Capacidade",
            interments_qty: "Nº Falecidos"
        },
        buttons: {
            save: "@:global.save",
            delete: "@:global.remove",
            export: "@:global.export",
            print: "@:global.print",
            view: "@:global.form",
            interment: {
                view: "Visualizar",
                add: "Adicionar Falecido"
            },
            deed_owner: {
                view: "Propriedade",
                add: "Adicionar Proprietário"
            },
            view_on_map: "@:global.view-on-map",
            view_data: "Consultar Informação"
        },
        msg: {
            "confirm-delete": "Deseja eliminar o Ocupação <strong class='font-weight-bold'>{code}</strong>?"
        }
    },
    sectors: {
        titles: "Setores",
        title: "Setor",
        label: "@:sectors.titles",
        title_modal: "Adicionar Setor | Setor: {code}",
        model: {
            cemetery: "@:cemeteries.title",
            number: "Número",
            code: "Código",
            sector_type: "Tipo",
            status: "Ativo",
            obs: "Observações",
            area: "Área",
            perimeter: "Perímetro"
        },
        form: {
            code_template: "{cemetery} {number}"
        },
        list: {},
        msg: {
            view_form: "Formulário",
            view_on_map: "@:global.view-on-map",
            "confirm-delete": "Deseja eliminar o setor <strong class='font-weight-bold'>{code}</strong>?",
            export: {
                confirm: "Deseja exportar o setor <strong class='font-weight-bold'>{code}</strong> para <strong class='font-weight-bold'>{format}</strong>?",
                processing: "A exportar o setor...",
                processed: "Exportação concluída"
            }
        },
        buttons: {
            save: "@:global.save",
            delete: "@:global.remove",
            export: "@:global.export",
            print: "@:global.print",
            edit: "@:global.edit",
            view_on_map: "@:global.view-on-map",
            view_data: "Consultar Informação"
        }
    },
    entities: {
        titles: "Pessoas",
        title: "Pessoa",
        title_modal: "Adicionar Pessoa | Pessoa: {name}",
        model: {
            name: "Nome",
            email: "Email",
            phone: "Contato",
            gender: "Género",
            religion: "Religião",
            birth_at: "Nascimento",
            death_at: "Falecimento",
            address: "Morada",
            full_address: "Morada",
            locality: "Localidade",
            postal_code: "CP7",
            occupation: "Ocupação",
            cause_death: "Causa da morte",
            father_affiliation: "Pai",
            mother_affiliation: "Mãe",
            use_personal_data: "Consentimento",
            tax_number: "NIF",
            obs: "Observações",
            from_age: "De",
            to_age: "A",
            years: "Anos",
            age: "Idade",
            templateCreate: 'Criar "{label}"',
            deed_owner: "@:deed_owners.title",
            occupations: "@:occupations.title"
        },
        form: {
            deceased: "Falecido",
            deceased_entity: "Pessoa falecida",
            address: "Morada",
            last_known_address: "Ultima morada conhecida",
            age: "Idade",
            type: {
                holder: "Proprietário",
                applicant: "Requerente"
            }
        },
        buttons: {
            save: "@:global.save",
            delete: "@:global.remove",
            export: "@:global.export",
            print: "@:global.print",
            edit: "@:global.edit",
            details: "Detalhes Pessoa",
            view: "Visualizar",
            view_data: "Consultar Informação"
        },
        msg: {
            click_more_info: "Clicar para consultar mais informação",
            "confirm-delete": "Deseja eliminar o a entidade <strong class='font-weight-bold'>{code}</strong>?"
        }
    },
    deed_owners: {
        titles: "Propriedade",
        title: "Propriedade",
        title_modal: "Adicionar Propriedade | Propriedade",
        model: {
            cemetery: "@:cemeteries.title",
            occupation: "@:occupations.title",
            right_type: "Direito", // A ‘right of interment’ is given when you purchase a grave or cremation memorial. It gives you the ‘right’ to use that cemetery plot for burial or cremated remains.
            term_right_type: "Prazo",
            application_at: "Adquirido em",
            expiry_at: "Expira em",
            process_number: "Nº processo",
            license_number: "Nº Alvará",
            license_number_at: "Data Alvará",
            license_number_book: "Livro",
            license_number_sheet: "Folha",
            certificate_number: "Nº certificação",
            registration_number: "Nº registo",
            service_need: "Necessidade de Serviço",
            payment_at: "Data Pagamento",
            fee: "Custos",
            fee_paid: "Pago",
            paid: "Pago",
            not_paid: "Em falta",
            files: "Documentos",
            obs: "Observações",
            from_fee: "De",
            to_fee: "A"
        },
        form: {
            license_number: "Alvará",
            fee: "Custos",
            holder: "Proprietário",
            applicant: "Requerente"
        },
        buttons: {
            save: "@:global.save",
            delete: "@:global.remove",
            export: "@:global.export",
            print: "@:global.print",
            cancel: "@:global.cancel",
            confirm: "@:global.confirm",
            holder: {
                add: "Proprietário",
                delete: "Remover"
            },
            applicant: {
                add: "Requerente",
                delete: "Remover"
            }
        },
        msg: {
            "confirm-delete-holder": "Deseja eliminar o proprietário <strong class='font-weight-bold'>{name}</strong>?"
        }
    },
    deed_owner_holders: {
        titles: "Proprietários",
        title: "Proprietário",
        title_modal: "Adicionar Proprietário | Proprietário: {code}",
        model: {
            start_type: "Motivo Inicial",
            start_at: "Início em",
            end_type: "Motivo Final",
            end_at: "Término em"
        },
        form: {
            entity: "Proprietário"
        },
        buttons: {
            save: "@:global.save",
            delete: "@:global.remove",
            export: "@:global.export",
            print: "@:global.print",
            cancel: "@:global.cancel",
            confirm: "@:global.confirm"
        }
    },
    interments: {
        titles: "Funerais",
        title: "Funeral",
        label: "@:interments.title",
        title_modal: "Adicionar Funeral | Funeral: {code}",
        model: {
            code: "Code",
            cemetery: "@:cemeteries.title",
            occupation: "@:occupations.title",
            interment_number: "Número funeral",
            interment_at: "Data funeral",
            interment_depth: "Profundidade enterro",
            interment_type: "Tipo funeral",
            cremation_location: "Local cremação",
            container_type: "Tipo Urna",
            container_dimensions: "Dimensões Urna(cm) - C x L x A",
            ceremony: "Cerimónia",
            obs: "Observações",
            fee: "Custos",
            fee_paid: "Pago",
            payment_at: "Data Pagamento",
            from_qty: "De",
            to_qty: "A",

            entity: {
                title: "@:entities.form.deceased_entity",
                name: "@:entities.model.name",
                birth_at: "@:entities.model.birth_at",
                death_at: "@:entities.model.death_at",
                gender: "@:entities.model.gender",
                religion: "@:entities.model.religion",
                occupation: "@:entities.model.occupation",
                cause_death: "@:entities.model.cause_death",
                address: "@:entities.model.address",
                last_known_address: "@:entities.form.last_known_address",
                locality: "@:entities.model.locality",
                postal_code: "@:entities.model.postal_code",
                age: "@:entities.model.age",
                templateCreate: 'Criar "{label}"'
            },

            details: {
                title: "Detalhes do Funeral"
            },

            story: {
                title: "História"
            },

            files: {
                title: "Documentos"
            }
        },
        list: {
            cemetery: "@:cemeteries.title",
            occupation: "@:occupations.title",
            deceased: "@:entities.form.deceased",
            last_known_address: "@:entities.form.last_known_address",
            gender: "@:entities.model.gender",
            birth_at: "@:entities.model.birth_at",
            death_at: "@:entities.model.death_at",
            age: "@:entities.model.age",
            cause_death: "Causa Morte",
            interment_number: "Nº funeral",
            interment_at: "Data funeral",
            interment_type: "Tipo funeral"
        },
        form: {
            details: "Detalhes do Funeral",
            qty: "Quantidade de Funerais",
            last_known_address: "@:entities.form.last_known_address"
        },
        buttons: {
            save: "@:global.save",
            delete: "@:global.remove",
            export: "@:global.export",
            print: "@:global.print",
            cancel: "@:global.cancel",
            confirm: "@:global.confirm",
            view_on_map: "@:global.view-on-map",
            view_data: "Consultar Informação",
            view_occupation: "Consultar Ocupação"
        },
        msg: {
            "confirm-delete": "Deseja eliminar o Funeral <strong class='font-weight-bold'>{code}</strong>?"
        }
    },
    navsearch_advanced: {
        title: "Pesquisa Avançada",
        cemetery: {
            title: "@:cemeteries.title"
        },
        buttons: {
            clear: "@:global.clear",
            cancel: "@:global.cancel",
            search: "@:global.search"
        }
    },
    search: {
        titles: "Filtros",
        title: "Filtros",
        label: "Filtros",
        model: {
            cemetery: {
                title: "@:cemeteries.title"
            }
        },
        tabs: {
            sectors: "@:sectors.titles",
            occupations: "@:occupations.titles",
            interments: "@:interments.titles",
            entities: "@:entities.titles",
            deed_owners: "@:deed_owners.titles"
        },
        list: {
            actions: {
                "view-data": {
                    title: "Consultar Informação",
                    help: null
                },
                "view-on-map": {
                    title: "Visualizar no mapa",
                    help: null
                }
            }
        }
    }
};
